// extracted by mini-css-extract-plugin
export default {"root":"accountVerificationPopup_root__AhsT9"};